<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NI0Clt/tc-custom/9781398437869.jpg?1705539731902" alt="This image is the cover for the book Lady and the Tramp and Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady and the Tramp and Me
      </h1>
      <p class="bookDescription body article font2">
        <p>Life doesn’t always turn out the way you think it should, does it? For instance, what happens when you get a puppy you don’t want? For Simon that answer is simply: nothing good. His life as a happy bachelor is torpedoed when he reluctantly accepts a puppy of indeterminable breed who names himself Tramp and seemingly never ever stops growing – personality included. Any principles for raising a dog are put to the test, and so is Simon’s state of mind when his sex-life is sabotaged, his sports car rendered useless, and Tramp is spending all of Simon’s money. And then there’s the women… quite a few of them, but one in particular. The angry one in the park who likes dogs and who wonders if Simon is a stripper because he flashes her his ass. But in reality, he looks like he’s just escaped from an asylum. And that’s just the beginning…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B.L. Berg
      </h2>
      
      <p class="authorDescription body article">When your brain constantly runs 100 miles an hour, you might as well put it to good use. And when you have a tattoo above your heart that says “storyteller”—then get to it. And that’s what B.L. Berg has done with her debut novel, Lady and the Tramp and Me. For her inspiration is everywhere, and nothing can become absolutely everything when she’s sitting behind the laptop. Visit her at: Facebook.com/BLBergAuthor Instagram.com/BLBergAuthor Also by B.L. Berg The Dream Maker and The Candy Cane</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?285d7995